import React, { useMemo } from "react";
import NumberFormat from "react-number-format";
import PropTypes from "prop-types";
import { numericOnBlur, numericOnChange } from "./utils";

const DecimalInput = ({
  inputRef,
  onChange,
  decimalScale,
  onBlur,
  ...props
}) => {
  const name = props.name;
  const bindedOnChange = useMemo(() => numericOnChange(onChange, name), [
    onChange,
    name,
  ]);
  const bindedOnBlur = useMemo(() => numericOnBlur(onBlur, name), [
    onBlur,
    name,
  ]);
  return (
    <NumberFormat
      fixedDecimalScale
      {...props}
      getInputRef={inputRef}
      decimalScale={decimalScale ?? 3}
      onBlur={bindedOnBlur}
      onValueChange={bindedOnChange}
      decimalSeparator={"."}
    />
  );
};

DecimalInput.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DecimalInput;
